export var AuditLogChangeSource;
(function (AuditLogChangeSource) {
    AuditLogChangeSource["CHANGE_SOURCE_UNSPECIFIED"] = "CHANGE_SOURCE_UNSPECIFIED";
    AuditLogChangeSource["CHANGE_SOURCE_UI"] = "UI";
    AuditLogChangeSource["CHANGE_SOURCE_API"] = "API";
    AuditLogChangeSource["CHANGE_SOURCE_SCHEDULER"] = "SCHEDULER";
    AuditLogChangeSource["CHANGE_SOURCE_SYSTEM"] = "SYSTEM";
    AuditLogChangeSource["CHANGE_SOURCE_SUPPORT"] = "SUPPORT";
})(AuditLogChangeSource || (AuditLogChangeSource = {}));
